export default __webpack_public_path__ + "static/media/blog.f2a59f97.jpg";